import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import classes from "./Watch.module.css";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { videolinkupdate, selectLink } from "../features/UserSlice";
import { useDispatch } from "react-redux";

export const Watch = (src) => {
  const Videoid = useSelector(selectLink);
  const dispatch = useDispatch();

  return (
    <div className={classes.watchscreen}>
      <div className={classes.back}>
        <button
          className={classes.back_btn}
          onClick={() => {
            dispatch(
              videolinkupdate({
                key: null,
              })
            );
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>
      <iframe
        src={`https://www.youtube.com/embed/${Videoid.key}?autoplay=1&loop=1&autopause=0&muted=1`}
        title="YouTube video player"
        allow="accelerometer;autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </div>
  );
};
